import type { CompanyEvents } from "@/modules/companies/client/api/types"

import { useQuery } from "@tanstack/react-query"

import { COMPANY_EVENTS_QUERY_KEY, getCompanyEvents } from "@/modules/companies/client/api/endpoints/companyEvents"
import { EVENTS_PAGE_SIZE, QUERY_CACHE_TIME, QUERY_STALE_TIME } from "@/modules/companies/client/constants/enums"
import { useCompanyFetch } from "@/modules/companies/client/hooks/useCompanyFetch"

export type CompanyEventsFetch = {
  dataCompanyEvents?: CompanyEvents
  isLoadingCompanyEvents: boolean
  isSuccessCompanyEvents: boolean
  isErrorCompanyEvents: boolean
}

export const useCompanyEventsFetch = (): CompanyEventsFetch => {
  const { dataCompany } = useCompanyFetch()

  const {
    data: dataCompanyEvents,
    isPending: isLoadingCompanyEvents,
    isSuccess: isSuccessCompanyEvents,
    isError: isErrorCompanyEvents,
  } = useQuery({
    enabled: !!dataCompany?.id,
    gcTime: QUERY_CACHE_TIME,
    queryFn: () => getCompanyEvents({ company_id: dataCompany?.id as string, page: 0, page_size: EVENTS_PAGE_SIZE }),
    queryKey: [COMPANY_EVENTS_QUERY_KEY, dataCompany?.id],
    staleTime: QUERY_STALE_TIME,
  })

  return {
    dataCompanyEvents,
    isErrorCompanyEvents,
    isLoadingCompanyEvents,
    isSuccessCompanyEvents,
  }
}
